// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3uWnv","notes":"Notes_notes__33t7e"};